import { render, staticRenderFns } from "./CollapsibleIconButton.vue?vue&type=template&id=39ba8a32"
import script from "./CollapsibleIconButton.vue?vue&type=script&lang=ts"
export * from "./CollapsibleIconButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports